export default __webpack_public_path__ + "static/media/link-project.88ad8d8c.svg";